import React from "react";
import PropTypes from "prop-types";
import cl from "classnames";
import classes from "./styles.module.scss";

const SearchButton = ({ onClick, isLoading, isForm, hasLocation }) => (
  <button
    className={cl(
      "button button--dark",
      classes.SearchButton,
      { [classes["SearchButton--loading"]]: isLoading },
      { [classes["SearchButton--light"]]: isForm }
    )}
    onClick={onClick}
    disabled={!hasLocation}
  >
    {isForm ? "Search Spaces" : "Search"}
  </button>
);

SearchButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  isForm: PropTypes.bool,
  hasLocation: PropTypes.bool,
};

export default SearchButton;
